import { render, staticRenderFns } from "./companyDetail.vue?vue&type=template&id=01e05b22&scoped=true"
import script from "./companyDetail.vue?vue&type=script&lang=js"
export * from "./companyDetail.vue?vue&type=script&lang=js"
import style0 from "./companyDetail.vue?vue&type=style&index=0&id=01e05b22&prod&lang=scss&scoped=true"
import style1 from "./companyDetail.vue?vue&type=style&index=1&id=01e05b22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e05b22",
  null
  
)

export default component.exports